import {isFeatureEnabled} from '@github-ui/feature-flags'

// Single gate for the For You refresh stack. To graduate, delete the flag and this helper,
// then remove flag-off branches and their Legacy adapters.
export function isForYouRefreshEnabled() {
  return isFeatureEnabled('prs_overview_for_you_refresh')
}

// The combined summary builds on the refreshed items, so it is only on when the refresh is also on.
export function isForYouCombinedSummaryEnabled() {
  return isForYouRefreshEnabled() && isFeatureEnabled('prs_overview_for_you_combined_summary')
}
